module.exports = __webpack_public_path__ + "static/media/marta-wenta.4e509b21.jpg";